
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, ChangeDetectorRef, SimpleChanges, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyLeadProfileService } from '../property-lead-profile.service';
import { PropertyLeadProfile } from '../property-lead-profile';
import { OwnerLeadProfileService } from '@app/_components/owner-lead-profile/owner-lead-profile.service';
import { OwnerLeadProfileComponent } from '@app/_components/owner-lead-profile/owner-lead-profile/owner-lead-profile.component';
import { OwnerLeadProfile } from '@app/_components/owner-lead-profile/owner-lead-profile';
import { UserTitles } from '@app/_helpers/constants';
import { ActivatedRoute } from '@angular/router';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';

@Component({
    selector: 'app-property-lead-profile',
    templateUrl: './property-lead-profile.component.html',
    styleUrls: ['./property-lead-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyLeadProfileComponent implements OnInit {
	ownerLeadProfilesList: any;
	isDisplayOwnerProfile: boolean = true;
	titles !: any;
	countries: any;
	states: any;
	assignedToUserId;
	subjAdrStreet: any;
	subjAdrUnit: any;
	subjAdrCity: any;
	subjAdrState: any;
	subjAdrPostalCode: any;
	listingStatuses: any;
	targetPriorities: any;

	notesChatConfig: NotesChatConfig = {
		title: 'Property Lead Profile Notes',
		maxWidth: '100%',
		maxHeight: '400px',
		customClass: '',
		fieldsPosition: 'top',
		showFilters: true,
		showSortOptions: false,
		fillParent: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 150,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};
	private readonly phoneControlNames = ['subjAdrPhone', 'mailAdrPhone', 'mobilePhone', 'phone2'];
	constructor(
		private constantService: ConstantService,
		private primengConfig: PrimeNGConfig,
		private propertyLeadProfileService: PropertyLeadProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private ownerLeadProfileService: OwnerLeadProfileService,
		private activatedRoute: ActivatedRoute,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private cdRef: ChangeDetectorRef,
		private formBuilder: FormBuilder,
		@Optional() private dialogRef: MatDialogRef<PropertyLeadProfileComponent>,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.subjAdrStreet = data.addressStreetName,
			this.subjAdrUnit = data.addressUnit,
			this.subjAdrCity = data.addressCity;
		this.subjAdrState = data.addressState;
		this.subjAdrPostalCode = data.addressZip;
		this.isDisplayOwnerProfile = data.isDisplayOwnerProfile == false ? false : true,
			this.propertyLeadProfileId = data.propertyLeadProfile?.propertyLeadProfileId,
			this.propertyTypes = propertyLeadProfileService.propertyTypes;
		this.ownersList = propertyLeadProfileService.ownersList;
		this.titles = UserTitles;
		this.countries = this.constantService.countries;
		this.states = this.constantService.states;
		this.listingStatuses = propertyLeadProfileService.listingStatuses;
		this.targetPriorities = propertyLeadProfileService.targetPriorities;
		if (this.propertyLeadProfileId) {
			this.findById(this.propertyLeadProfileId);
		}
	}



	@Input() propertyLeadProfile: PropertyLeadProfile;

	// KBM 2026: Google Maps link computed from subject address fields.
	get googleMapsUrl(): string | null {
		const p: any = this.propertyLeadProfile;
		if (!p) return null;
		const parts = [p.subjAdrStreet, p.subjAdrUnit ? `Unit ${p.subjAdrUnit}` : null, p.subjAdrCity, p.subjAdrState, p.subjAdrPostalCode]
			.filter(s => !!s && String(s).trim().length > 0);
		if (parts.length === 0) return null;
		return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(parts.join(', '));
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doClose = new EventEmitter<any>();

	// data
	propertyLeadProfileId: number;
	ownerLeadProfileObj: OwnerLeadProfile[] = [];

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	propertyTypes: any;
	ownersList: any;

	validationMessages = {
		'propertyLeadProfileId': [],
		'firstName': [{ type: 'required', message: 'First Name Required' }],
		'lastName': [{ type: 'required', message: 'Last Name Required' }],
		'suffix': [],
		'title': [],
		'emailAddress': [],
		'emailAddress2': [], // new
		'mobilePhone': [],
		'careOf': [],
		phone2: [],
		fullName: [],
		ownerAge: [], // new
		vendorSrcId: [],
		vendorSrcName: [],    //String
		opsNotes: [],//String

		subjSaleDate: [],    // LocalDate
		subjSaleAmount: [],   //Double
		subjAppreciation: [],   //Double
		subjValue: [],   //Double
		subjLegalDesc: [],  //String
		subjLocationDesc: [],  //String
		subjAdrCountyId: [],   //String


		subjAdrDevelopmentName: [],
		subjAdrStreet: [{ type: 'required', message: 'Required' }],
		subjAdrUnit: [],
		subjAdrStreet2: [],
		subjAdrCity: [{ type: 'required', message: 'Required' }],
		subjAdrState: [{ type: 'required', message: 'Required' }],
		subjAdrPostalCode: [{ type: 'required', message: 'Required' }],
		subjAdrCountry: [],
		subAdrIsland: [],

		subjAdrRegion: [],// new
		subjAdrDistrict: [],// new
		subjAdrPhone: [],// new
		subjAdrFax: [],// new


		mailAdrCompanyName: [],
		mailAdrStreet: [],
		mailAdrStreet2: [],
		mailAdrCity: [],
		mailAdrState: [],
		mailAdrPostalCode: [],
		mailAdrCountry: [],
		mailAdrPhone: [],
		mailAdrFax: [],
		'propertyType': [],
		'parcelId': [],
		// 'propertyValue': [],
		'bedroomNum': [],
		'bathroomNum': [],
		'floorOfProperty': [],
		'floorsInBuilding': [],
		'yearBuilt': [],
		'sizeInterior': [],
		'sizeExterior': [],
		'ownershipType': [],
		'vrboId': [],
		'airbnbId': [],
		'ownerLeadProfiles': [],
		ownerPointId: [],
		listingStatus: [],
		targetPriorityNum: []

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.fetchOwnerLeadProfiles();
		this.formBuild();

		// if we were passed the whole propertyLeadProfile object
		if (this.propertyLeadProfile) {
			this.propertyLeadProfileId = this.propertyLeadProfile.propertyLeadProfileId;
			this.fixDates();
			this.form1.patchValue(this.propertyLeadProfile);
			this.formatAllPhoneFields();
			//Default make form as dirty
			this.form1.markAllAsTouched();
		} else {
			this.activatedRoute.params.subscribe(params => {
				this.propertyLeadProfileId = params.propertyLeadProfileId; // (+) converts string 'id' to a number
			});
			if (this.propertyLeadProfileId != null && this.propertyLeadProfileId != undefined) {
				this.findById(this.propertyLeadProfileId);
			}
		}

	}

	findById(propertyLeadProfileId: any) {
		try {
			//pass this.confId in parameter below in kbmresorts
			this.propertyLeadProfileService.findById(propertyLeadProfileId)
				.subscribe(
					(res: any) => {
						console.log('PropertyLeadProfile Data: ' + JSON.stringify(res));
						this.propertyLeadProfile = res.data.propertyLeadProfile;
						// if we were passed the whole propertyLeadProfile object
						if (this.propertyLeadProfile) {
							this.propertyLeadProfileId = this.propertyLeadProfile.propertyLeadProfileId;
							this.fixDates();
							// Assuming ownerLeadProfiles is an array of objects with IDs, you need to map them correctly
							const selectedProfiles = this.propertyLeadProfile.ownerLeadProfiles || [];
							let ownerList = [];
							if (this.ownerLeadProfilesList) {
								// Match selected profiles from ownerLeadProfilesList
								ownerList = this.ownerLeadProfilesList.filter(ownerLead =>
									selectedProfiles.some(selectOwnerLead => selectOwnerLead.ownerLeadProfileId === ownerLead.ownerLeadProfileId)
								);
							}
							this.form1.patchValue(this.propertyLeadProfile);
							// Patch the form with the matched owner profiles
							this.form1.patchValue({
								ownerLeadProfiles: ownerList // Ensure this is an array of objects
							});
							this.formatAllPhoneFields();
						}
						this.cdRef.detectChanges();
						//Default make form as dirty
						this.form1.markAllAsTouched();
					},
					(err: any) => {
						console.log('Get propertyLeadProfile data FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Get propertyLeadProfile data FAIL: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyLeadProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyLeadProfileService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyLeadProfile = res.data.propertyLeadProfile;
						this.doAdd.emit(this.propertyLeadProfile);
					},
					(err: any) => {
						console.log('propertyLeadProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('propertyLeadProfile: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.propertyLeadProfileId = this.propertyLeadProfileId;
			this.propertyLeadProfileService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyLeadProfile = res.data.propertyLeadProfile;
						this.doUpdate.emit(this.propertyLeadProfile);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	setAssignedToUserId($event) {
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	formDelete() {
		try {
			this.propertyLeadProfileService.delete(this.propertyLeadProfile.propertyLeadProfileId)
				.subscribe(
					(res: any) => {
						console.log('propertyLeadProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.propertyLeadProfile);
					},
					(err: any) => {
						console.log('propertyLeadProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyLeadProfileId: [this.propertyLeadProfileId],
			firstName: [],
			lastName: [],
			suffix: [],
			title: [],
			emailAddress: [],
			emailAddress2: [], // new
			mobilePhone: [],
			careOf: [],
			subjAdrUnit: [this.subjAdrUnit],
			phone2: [],
			fullName: [],
			ownerAge: [], // new
			vendorSrcId: [],
			vendorSrcName: [],    //String
			opsNotes: [],//String

			subjSaleDate: [],    // LocalDate
			subjSaleAmount: [],   //Double
			subjAppreciation: [],   //Double
			subjValue: [],   //Double
			subjLegalDesc: [],  //String
			subjLocationDesc: [],  //String
			subjAdrCountyId: [],   //String

			subjAdrDevelopmentName: [],
			subjAdrStreet: [this.subjAdrStreet, Validators.required],
			subjAdrStreet2: [],
			subjAdrCity: [this.subjAdrCity, Validators.required],
			subjAdrState: [this.subjAdrState, Validators.required],
			subjAdrPostalCode: [this.subjAdrPostalCode, Validators.required],
			subjAdrCountry: ['US'],

			subAdrIsland: [],
			subjAdrRegion: [],// new
			subjAdrDistrict: [],// new
			subjAdrPhone: [],// new
			subjAdrFax: [],// new

			mailAdrCompanyName: [],
			mailAdrStreet: [],
			mailAdrStreet2: [],
			mailAdrCity: [],
			mailAdrState: [],
			mailAdrPostalCode: [],
			mailAdrCountry: [],
			mailAdrPhone: [],
			mailAdrFax: [],
			propertyType: [],
			parcelId: [],
			// propertyValue: [],
			bedroomNum: [],
			bathroomNum: [],
			floorOfProperty: [],
			floorsInBuilding: [],
			yearBuilt: [],
			sizeInterior: [],
			sizeExterior: [],
			ownershipType: [],
			vrboId: [],
			airbnbId: [],
			ownerLeadProfiles: [],
			ownerPointId: [],
			listingStatus: [],
			targetPriorityNum: []

		});
	}


	formatPhoneField(controlName: string): void {
		const control = this.form1.get(controlName);
		if (!control) return;
		const raw = (control.value || '').toString().replace(/\D/g, '');
		const digits = raw.slice(0, 10);
		const formatted = digits.length <= 3
			? digits
			: digits.length <= 6
				? `${digits.slice(0, 3)}-${digits.slice(3)}`
				: `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
		if (formatted !== control.value) {
			control.patchValue(formatted, { emitEvent: false });
		}
	}

	formatAllPhoneFields(): void {
		this.phoneControlNames.forEach(name => this.formatPhoneField(name));
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.propertyLeadProfile.propertyLeadProfileDate = moment(this.propertyLeadProfile.propertyLeadProfileDate).toDate();
	}

	formAddPropertyLead() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Owner Lead Profile",
			isDisplayPropertyProfile: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			OwnerLeadProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);

			this.ownerLeadProfilesList = [];
			this.fetchOwnerLeadProfiles();


			if (this.propertyLeadProfile) {
				this.propertyLeadProfile?.ownerLeadProfiles.unshift(data);

				// no idea what this is but it is required to update the array
				this.propertyLeadProfile.ownerLeadProfiles = [...this.propertyLeadProfile?.ownerLeadProfiles];
				this.form1.patchValue({
					ownerLeadProfileVOList: this.propertyLeadProfile?.ownerLeadProfiles
				});

			}
			else {

				console.log("DATA :: " + data);
				this.ownerLeadProfileObj.push(data);
				console.log("ownerLeadProfileObj :: " + JSON.stringify(this.ownerLeadProfileObj));

				this.form1.patchValue({
					ownerLeadProfileVOList: this.ownerLeadProfileObj
				});
			}
			// close the dialogBox
			dialogRef.close();

		});
	}

	fetchOwnerLeadProfiles() {
		try {
			this.ownerLeadProfileService.findAll()
				.subscribe(
					res => {
						console.log('ownerLeadProfileService: ' + JSON.stringify(res));
						// this.ownerLeadProfilesList = res.data.ownerLeadProfiles;
						this.ownerLeadProfilesList = res.data.ownerLeadProfiles.map(owner => ({
							...owner,
							customName: owner.firstName && owner.emailAddress
								? `${owner.firstName} (${owner.emailAddress})`
								: owner.firstName || owner.emailAddress || 'Unknown'
						}));
						// this.findById(this.propertyLeadProfileId);
						let ownerList = [];
						if (this.ownerLeadProfilesList && this.ownerLeadProfilesList.length > 0) {
							if (this.propertyLeadProfile) {
								const selectedProfiles = this.propertyLeadProfile.ownerLeadProfiles || [];
								// Match selected profiles from ownerLeadProfilesList
								ownerList = this.ownerLeadProfilesList.filter(ownerLead =>
									selectedProfiles.some(selectOwnerLead => selectOwnerLead.ownerLeadProfileId === ownerLead.ownerLeadProfileId)
								);
								this.form1.patchValue({
									ownerLeadProfiles: ownerList // Ensure this is an array of objects
								});
							}
						}
						this.cdRef.detectChanges();
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	closePopUpOfQuote() {
		this.doUpdate.emit("close");

		this.dialogRef ? this.dialogRef.close() : '';
	}

	/*
	Create Hoemowner Lead
	*/


	onCreateLeadConfirm(): void {
		if (this.form1?.invalid) {
			this.messageService.add({
				severity: 'warn',
				summary: 'Form incomplete',
				detail: 'Please fix validation errors before creating a lead.'
			});
			return;
		}

		this.confirmationService.confirm({
			message: 'Create a new Owner Lead?',
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: () => this.onCreateLead(),
			reject: () => {
				this.messageService.add({
					severity: 'info',
					summary: 'Canceled',
					detail: 'No lead was created.'
				});
			}
		});
	}

	onCreateLead(): void {
		try {
			this.formLoading = true;

			// 🔧 Call your API (adjust method/signature to your service)
			this.ownerLeadProfileService.createOwnerLeadFromPropertyLead(this.propertyLeadProfileId).subscribe(
				(res: any) => {
					this.messageService.add({
						severity: 'success',
						summary: 'Lead created',
						detail: 'Homeowner lead created successfully.'
					});
					// optional: close dialog or navigate
					// this.closePopUpOfQuote();
				},
				(err: any) => {
					this.messageService.add({
						severity: 'error',
						summary: 'Create failed',
						detail: 'Could not create the lead.'
					});
				},
				() => (this.formLoading = false)
			);
		} catch (e) {
			this.formLoading = false;
			this.messageService.add({
				severity: 'error',
				summary: 'Error',
				detail: 'Unexpected error creating the lead.'
			});
		}
	}
}
